import { render, staticRenderFns } from "./applyMy.vue?vue&type=template&id=01992928&scoped=true&"
import script from "./applyMy.vue?vue&type=script&lang=js&"
export * from "./applyMy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01992928",
  null
  
)

export default component.exports